// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1D-Nu","location":"Header_location__3BtDt"};